export default {
	company_agency: 'Loja',
	my_score: 'Meus BitCORs',
	no_company_agency_found: 'Nenhuma loja encontrada',
	'points,': 'BitCORs',
	price: 'BitCORs',
	project_name: 'Academia Coral',
	score: 'BitCORs',
	search_for_your_address: 'Busque pelo seu CEP OU endereço OU cidade',
	you_can_recover_your_password_using_your_email_or_document_or_sms:
		"Clique em 'Esqueci minha senha' e escolha recuperar por E-mail (digitando CPF) ou por SMS (digitando celular) e receba um LINK para fazer sua nova senha. ",
	user: 'Usuário (CPF ou E-mail)',
	use_your_email_or_document_to_recover_your_password: 'Utilize seu CPF ou e-mail para recuperar sua senha'
}
